'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var toast = require('./toast.js');
var toast_utils = require('./toast.utils.js');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var initialState = {
  top: [],
  'top-left': [],
  'top-right': [],
  'bottom-left': [],
  bottom: [],
  'bottom-right': []
};

/**
 * Store to track all the toast across all positions
 */
// eslint-disable-next-line @typescript-eslint/no-use-before-define
var toastStore = createStore(initialState);

// eslint-disable-next-line @typescript-eslint/no-shadow
function createStore(initialState) {
  var state = initialState;
  var listeners = new Set();
  var setState = function setState(setStateFn) {
    state = setStateFn(state);
    listeners.forEach(function (l) {
      return l();
    });
  };
  return {
    getState: function getState() {
      return state;
    },
    subscribe: function subscribe(listener) {
      listeners.add(listener);
      return function () {
        // Delete all toasts on unmount
        setState(function () {
          return initialState;
        });
        listeners["delete"](listener);
      };
    },
    /**
     * Delete a toast record at its position
     */
    removeToast: function removeToast(id, position) {
      setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty__default["default"]({}, position, prevState[position].filter(function (toast) {
          return toast.id != id;
        })));
      });
    },
    notify: function notify(message, options) {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      var toast = createToast(message, options);
      var position = toast.position,
        id = toast.id;
      setState(function (prevToasts) {
        var _prevToasts$position, _prevToasts$position2;
        var isTop = position.includes('top');

        /**
         * - If the toast is positioned at the top edges, the
         * recent toast stacks on top of the other toasts.
         *
         * - If the toast is positioned at the bottom edges, the recent
         * toast stacks below the other toasts.
         */
        var toasts = isTop ? [toast].concat(_toConsumableArray__default["default"]((_prevToasts$position = prevToasts[position]) !== null && _prevToasts$position !== void 0 ? _prevToasts$position : [])) : [].concat(_toConsumableArray__default["default"]((_prevToasts$position2 = prevToasts[position]) !== null && _prevToasts$position2 !== void 0 ? _prevToasts$position2 : []), [toast]);
        return _objectSpread(_objectSpread({}, prevToasts), {}, _defineProperty__default["default"]({}, position, toasts));
      });
      return id;
    },
    update: function update(id, options) {
      if (!id) return;
      setState(function (prevState) {
        var nextState = _objectSpread({}, prevState);
        var _findToast = toast_utils.findToast(nextState, id),
          position = _findToast.position,
          index = _findToast.index;
        if (position && index !== -1) {
          nextState[position][index] = _objectSpread(_objectSpread(_objectSpread({}, nextState[position][index]), options), {}, {
            message: toast.createRenderToast(options)
          });
        }
        return nextState;
      });
    },
    closeAll: function closeAll() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        positions = _ref.positions;
      // only one setState here for perf reasons
      // instead of spamming this.closeToast
      setState(function (prev) {
        var allPositions = ['bottom', 'bottom-right', 'bottom-left', 'top', 'top-left', 'top-right'];
        var positionsToClose = positions !== null && positions !== void 0 ? positions : allPositions;
        return positionsToClose.reduce(function (acc, position) {
          acc[position] = prev[position].map(function (toast) {
            return _objectSpread(_objectSpread({}, toast), {}, {
              requestClose: true
            });
          });
          return acc;
        }, _objectSpread({}, prev));
      });
    },
    close: function close(id) {
      setState(function (prevState) {
        var position = toast_utils.getToastPosition(prevState, id);
        if (!position) return prevState;
        return _objectSpread(_objectSpread({}, prevState), {}, _defineProperty__default["default"]({}, position, prevState[position].map(function (toast) {
          // id may be string or number
          // eslint-disable-next-line eqeqeq
          if (toast.id == id) {
            return _objectSpread(_objectSpread({}, toast), {}, {
              requestClose: true
            });
          }
          return toast;
        })));
      });
    },
    isActive: function isActive(id) {
      return Boolean(toast_utils.findToast(toastStore.getState(), id).position);
    }
  };
}

/**
 * Static id counter to create unique ids
 * for each toast
 */
var counter = 0;

/**
 * Create properties for a new toast
 */
function createToast(message) {
  var _options$id, _options$position;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  counter += 1;
  var id = (_options$id = options.id) !== null && _options$id !== void 0 ? _options$id : counter;
  var position = (_options$position = options.position) !== null && _options$position !== void 0 ? _options$position : 'bottom';
  return {
    id: id,
    message: message,
    position: position,
    duration: options.duration,
    onCloseComplete: options.onCloseComplete,
    onRequestRemove: function onRequestRemove() {
      return toastStore.removeToast(String(id), position);
    },
    status: options.status,
    requestClose: false,
    containerStyle: options.containerStyle
  };
}
exports.toastStore = toastStore;